export default "__VITE_ASSET__B34msuvi__"